import { IDialogContentProps } from "@fluentui/react";
import { IValidationMessage } from "components/controls/ValidationView/ValidationView.type";
import { ISaveInstruction } from "global/Application/dataActions";

export interface IProps {
    dialogContentProps?: IDialogContentProps;
    onClose: () => void;
    onContinue: () => void;
    children: React.ReactNode;
}

export interface IValidationModel<T = any> {
    id?: string;
    name?: string;
    validationMessages: IValidationMessage[],
    state: EValidationState,
    data?: T
}

export enum EValidationState {
    Idle,

    // process is running
    Validating,

    // pending a user decision to move forward
    PendingUser,

    // cancelling further requests 
    Rejected,

    // verified and ready to move forward
    Fulfilled
}
